export const ticketRedirectDtoRedirectToEnum = {
  '1': 1,
  '2': 2,
} as const

export type TicketRedirectDtoRedirectToEnum = (typeof ticketRedirectDtoRedirectToEnum)[keyof typeof ticketRedirectDtoRedirectToEnum]

export type TicketRedirectDto = {
  /**
   * @type number
   */
  redirect_to: TicketRedirectDtoRedirectToEnum
}